import React, { useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Stack, Typography } from "@mui/material";

import { State } from "./CreateReportSection";
import { SelectSet } from "./SelectSet";

interface Props {
  data: { set_id: State["cashflow_graph"]["set_id"]; queries: State["queries"] };
  onSubmit: (data: { queries: State["queries"]; set_id: State["cashflow_graph"]["set_id"] }) => void;
  onCancel: () => void;
}

export const EditSet: React.FC<Props> = ({ onCancel, data, onSubmit }) => {
  const [set, setSet] = useState<State["cashflow_graph"]>({ set_id: data.set_id });
  const [queries, setQueries] = useState<State["queries"]>(data.queries);

  return (
    <Stack
      sx={{
        outline: "none",
        bgcolor: "white",
        minWidth: 300,
        p: "32px",
        gap: "20px",
        borderRadius: "8px",
        borderShadow: "sm",
        maxHeight: "500px",
        overflow: "hidden"
      }}
    >
      <Stack sx={{ flexDirection: "row", justifyContent: "space-between", borderBottom: "1px solid #DBE8F5" }}>
        <Typography sx={{ fontSize: "18px", fontWeight: 400, lineHeight: "24px" }}>Table</Typography>
        <IconButton onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <Stack sx={{ overflow: "auto", pt: "6px" }}>
        <SelectSet data={{ set_id: set.set_id, queries }} setData={setSet} setQueriesData={setQueries} />
      </Stack>
      <Stack sx={{ flexDirection: "row", justifyContent: "flex-end", gap: "8px" }}>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" onClick={() => set.set_id && queries && onSubmit({ set_id: set.set_id, queries })}>
          Confirm
        </Button>
      </Stack>
    </Stack>
  );
};
